// Types
import { useDashboardColor } from "../../context/DashboardColorContext";
import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";

// Utils
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import BannerRibbon from "../BannerRibbon";
import MetricBarChart from "../charts/MetricBarChart";

// Components
import MetricCard from "../MetricCard";

const AccessibilityMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("accessibility data:", sortedMetrics);

    const color = useDashboardColor();

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const a: DisaggregatedMetric[] = sortedMetrics[0];
    const commute = indicators?.find(i => i.id === 1253);

    return (
        <div className="mx-auto px-4 pb-8 pt-4">
            <BannerRibbon text="Accessibility"/>
            <div className="grid grid-cols-2 gap-4">
                {a?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                {commute &&
                    <div className="w-full mt-2 col-span-2">
                        <MetricBarChart 
                            metric={commute} 
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            height="h-36" 
                            background="bg-white"
                            barColor={color}
                        />
                    </div>
                }
            </div>
        </div>
    );
}

export default AccessibilityMetrics;